import { Button, Card, CardBody, CardFooter, CardTitle, Grid, GridItem, Title } from '@patternfly/react-core';
import * as React from 'react';
import PageInterface from '@app/Interface/PageInterface';
import AcfImageInterface from '@app/Interface/AcfImageInterface';


interface DailyChurnProps {
    currentFpuId: number;
    pageData: PageInterface;
}

const DailyChurn: React.FC<DailyChurnProps> = ({ currentFpuId, pageData }) => {

    return (
        <>
            <Title headingLevel={'h2'} className="pf-u-mb-md">
                {pageData.acf.daily_churn_title || 'The Daily Churn'}
            </Title>
            <Card id="daily-churn-card" isFlat>
                <Grid md={6}>
                    {typeof pageData.acf.daily_churn_image === 'object' &&
                        <GridItem className="pf-u-min-height" md={3} style={
                            {
                                // https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
                                ['--pf-u-min-height--MinHeight-on-md' as any]: '200px', 
                                ['--pf-u-min-height--MinHeight' as any]: '300px', 
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundImage: `url(${pageData.acf.daily_churn_image?.sizes.medium})`
                            }
                        } />
                    }
                    <GridItem md={9}>
                        {pageData.acf.daily_churn_description &&
                            <CardBody>
                                {pageData.acf.daily_churn_description}
                            </CardBody>
                        }
                        <CardFooter>
                            <Button
                                variant="tertiary"
                                component="a"
                                href={pageData.acf.daily_churn_link?.url}
                                target={pageData.acf.daily_churn_link?.target || '_self'}
                            >
                                {pageData.acf.daily_churn_link?.title || 'Read the Daily Churn'}
                            </Button>
                        </CardFooter>
                    </GridItem>
                </Grid>
            </Card>
        </>
    );

}

export default DailyChurn;